import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=3a2dcc70&"
import script from "./Layout.vue?vue&type=script&setup=true&lang=js&"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports